import { FC } from "react";
import logoUrl from "../assets/images/cplogo.png";

export const Logo: FC = (props: any) => {
  return (
      <a href="/">  <img src={logoUrl} alt="Logo" height="auto" width="100%" /></a>
  );
};
